import React, { useCallback, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
  RadConnStyle as radStyle,
} from "../../../features/RadConnStyle";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import { FormAutoB } from "../../../core/Helper";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../../features/UserActions";

export default function BranchPacsPopup(props) {
  const userDetail = useSelector((state) => state.user.detail);
  const [winState, setWinState] = props.winState;
  const { selectedRow, dataX, formName, setUpdateFlag } = props;
  const [data, setData] = useState(null);
  const refForm1 = useRef(null);
  const dispatch = useDispatch();
  //----------------------------------------------------------------------
  useEffect(() => {
    if (selectedRow) {
      getData(() => {
        selectedRow.action("ready");
      });
    }
  }, [selectedRow]);

  //----------------------------------------------------------------------
  const getData = (goReady) => {
    if (
      selectedRow &&
      selectedRow.row &&
      selectedRow.row.pacs_server_id === 0
    ) {
      setData(null);
      goReady();
      return;
    }
    axios
      .post(
        process.env.REACT_APP_API + "api/branchpacs/get-data",
        selectedRow.row,
        HttpJsonHeader
      )
      .then((res) => {
        if (res.data.rows && res.data.rows.length > 0) {
          setData(res.data.rows[0]);
          goReady();
        }
      })
      .catch((err) =>
        dispatch(setReminder({ show: true, message: err.message }))
      );
  };

  //----------------------------------------------------------------------
  //Saving Data TO server
  const saveData = (evt) => {
    const dForm1 = new FormData(refForm1.current);
    const fData1 = Object.fromEntries(dForm1);

    let dataToSave = {
      ItemId: selectedRow.row["pacs_server_id"],
      SaveInfo: { ...fData1, brchid: userDetail.brchid },
      UserDetail: userDetail,
    };

    if (selectedRow.pacs_server_id === 0) {
      dataToSave.SaveInfo = {
        ...dataToSave.SaveInfo,
        createby: userDetail.userid,
      };
    } else {
      dataToSave.SaveInfo = {
        ...dataToSave.SaveInfo,
        updateby: userDetail.userid,
      };
    }

    axios
      .post(
        process.env.REACT_APP_API + "api/branchpacs/update",
        dataToSave,
        HttpJsonHeader
      )
      .then((res) => {
        dispatch(
          setReminder({ show: true, message: "บันทึกสมบูรณ์", type: "success" })
        );
        setWinState({ show: false });
        setUpdateFlag(true);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  //----------------------------------------------------------------------
  // FIELDS Ojbect list
  const FILEDS = [
    {
      label: "User",
      oName: "userid",
      require: true,
      type: "select",
      rows: dataX && dataX.PacsList && dataX.PacsList,
    },
    { label: "AE Title", oName: "ae_title", require: true, type: "text" },
    { label: "Local IP", oName: "local_ip", require: true, type: "text" },
    { label: "Local Port", oName: "local_port", require: true, type: "text" },
    {
      label: "PACS_GUID",
      oName: "sv_partition_guid",
      require: true,
      type: "text",
    },
    { label: "Public IP", oName: "public_ip", require: true, type: "text" },
    { label: "URL", oName: "url", require: true, type: "text" },
  ];
  //----------------------------------------------------------------------
  // Return Zone
  return (
    <MyModal show={winState.show} size="lg" centered backdrop={false}>
      <ModalHeaderBlack style={{ textAlign: "center" }} closeButton>
        เพิ่มแก้ไข {`${formName ? formName : "รายการ"}`}
      </ModalHeaderBlack>

      <ModalBodyBlack>
        {FILEDS ? (
          <FormAutoB
            {...{ formId: "form1", items: FILEDS, data: data, refTo: refForm1 }}
          />
        ) : null}
      </ModalBodyBlack>

      <ModalFooterBlack>
        <Button variant="primary" onClick={() => saveData()}>
          Save changes
        </Button>
        <Button variant="danger" onClick={() => setWinState({ show: false })}>
          Close
        </Button>
      </ModalFooterBlack>
    </MyModal>
  );
}
